import React, { useEffect } from "react"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import "../css/find-place.css"
import rightArrow from "../assets/images/for-student/right-arrow.png"
import waveHeader from "../assets/images/for-student/wave_header.png"
import comingFor1 from "../assets/images/for-student/comming-for-1.png"
import comingFor2 from "../assets/images/for-student/comming-for-2.png"
import element3 from "../assets/images/for-student/element_3.png"
import elementSol from "../assets/images/for-student/element_solutions.png"
import elementSolMob from "../assets/images/for-student/element_solutions_mob.png"
import undormImg from "../assets/images/for-student/undorm_image.png"
import waveUndorm from "../assets/images/for-student/wave_undorm.png"
import lineMob from "../assets/images/for-student/line-mob.png"
import element2 from "../assets/images/for-student/element_2.png"
import elementSo2 from "../assets/images/for-student/element_solutions_1.png"
import waveSolutions from "../assets/images/for-student/wave_solutions.png"
import Layer3 from "../assets/images/for-student/Layer_3.png"
import Layer4 from "../assets/images/for-student/Layer_4.png"
import Layer5 from "../assets/images/for-student/Layer_5.png"
import waveNessageMob from "../assets/images/for-student/wave_message_mob.png"
import "aos/dist/aos.css"
import AOS from "aos"
import { graphql } from "gatsby"
import { getImage, GatsbyImage, StaticImage } from "gatsby-plugin-image"
import { RiArrowRightSLine } from "react-icons/ri"

const FindingPlace = ({ data }) => {
  const {
    strapiFindingAPlace: {
      main_heading,
      main_para,
      main_img: { localFile },
      Time_to_undorm_heading,
      Time_to_undorm_para,
      the_process,
    },
  } = data

  const heroImg = getImage(localFile)

  useEffect(() => {
    AOS.init({
      disable: false,
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 100,
      throttleDelay: 99,
      offset: 120,
      delay: 0,
      duration: 1200,
      easing: "ease",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    })
  }, [])

  return (
    <Layout>
      <Seo Sitetitle="Finding a place" />
      <>
        <section className="hero-section">
          <div className="padding-left">
            <div className="container-fluid">
              <div className="row reverse-columan">
                <div
                  data-aos="fade-up"
                  className="col-lg-5 navigatin-details-outer"
                >
                  <p className="navigatin-details">
                    Home{" "}
                    <img
                      src={rightArrow}
                      className="img-fluid mx-2"
                      alt="right-arrow"
                    />{" "}
                    <b className="font-weight-bold">
                      {" "}
                      For Students - I'm Finding a Place
                    </b>
                  </p>
                  <h1 className="main-page-heading">{main_heading}</h1>
                  <div className="hero-para d-flex pl-lg-1">
                    <span className="main-wraper-hr" />
                    <span className="hero-para-txt">
                      {main_para}
                      <div className="left-border-line remove-from-mob" />
                      <br className="d-block" />
                      <div className="whitespace-no-wrap line-height">
                        Whether you're coming from
                      </div>
                    </span>
                  </div>
                </div>
                <div
                  data-aos="fade-right"
                  className="col-lg-7 pt-1 pr-lg-0 remove-padding position-relative"
                >
                  <GatsbyImage
                    image={heroImg}
                    className="img-fluid d-sm-inline-block"
                    alt="hero"
                  />
                  {/*                    <img src="images/for-student/hero-image-mob.png" class="img-fluid d-sm-none" alt="">*/}
                  <img
                    src={waveHeader}
                    className="img-fluid wave_img"
                    alt="wave_header"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="position-relative comming-from-section">
          <div className="container">
            <div className="row mt-4 position-relative">
              <div data-aos="fade-down" className="col-lg-6 pr-lg-0">
                <div className="comming-from text-center">
                  <h2>Dorm to Apartment</h2>
                  <img
                    src={comingFor1}
                    className="img-fluid mt-2"
                    alt="comming-for-1"
                  />
                </div>
              </div>
              <div data-aos="fade-left" className="col-lg-6 space-top-mob">
                <div className="comming-from text-center">
                  <h2>Apartment to Apartment</h2>
                  <img
                    src={comingFor2}
                    className="img-fluid mt-4"
                    alt="comming-for-2"
                  />
                </div>
              </div>
              <div className="or_btn">OR</div>
            </div>
            <div className="row mt-lg-5">
              <div
                data-aos="fade-up"
                className="offset-lg-6 col-lg-6 space-from-left-col"
              >
                <div className="left-border-line d-lg-none" />
                <div className="hero-para mt-4">
                  Normal rental transactions between brokers/agents and students
                  fall short of delivering a simple and stress free experience.
                </div>
                <div className="hero-para mt-4">
                  We aim to deliver a premium white glove service… at no charge
                  to you.
                </div>
              </div>
            </div>
          </div>
          <img
            data-aos="fade-up"
            src={element3}
            className="img-fluid comming-from-left"
            alt="element_3"
          />
        </section>
        <section className="position-relative undrom-section main-section padding-bottom">
          <img
            data-aos="fade-left"
            src={elementSol}
            className="img-fluid undrom_right d-lg-inline-block d-none"
            alt="element_solutions"
          />
          <img
            data-aos="fade-left"
            src={elementSolMob}
            className="img-fluid undrom_right img-bottom d-lg-none"
            alt="element_solutions"
          />
          <div className="position-relative">
            <div data-aos="fade-down" className="stroke-heading hide-left">
              undorm
            </div>
            <div data-aos="fade-down" className="undrom_img_outer">
              <img
                src={undormImg}
                className="img-fluid undrom_img"
                alt="undorm_image"
              />
            </div>
            <div className="time-to-undrom">
              <div className="container-fluid">
                <div className="row">
                  <div
                    data-aos="fade-right"
                    className="offset-lg-7 col-lg-5 offset-6 col-6 col-adjst-pdng"
                  >
                    <h3 className="main-heading">{Time_to_undorm_heading}</h3>
                    <div className="d-lg-flex opacity-0 mt-4">
                      <div className="time-to-undorm-line" />
                      <p className="hero-para time-to-undorm-para">
                        {Time_to_undorm_para}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              data-aos="fade-up"
              src={waveUndorm}
              className="img-fluid wave_undrom"
              alt="wave_undorm"
            />
          </div>
        </section>
        <section className="numbering-section">
          <div className="container">
            <div className="row">
              <div data-aos="fade-up" className="col-12 d-lg-none">
                <div className="d-flex mt-4">
                  <div className="time-to-undorm-line" />
                  <p className="hero-para time-to-undorm-para">
                    {Time_to_undorm_para}
                  </p>
                </div>
              </div>
              <div className="row position-relative">
                <img
                  src={lineMob}
                  className="img-fluid d-lg-none line-mob"
                  alt="line"
                />
              </div>
              {the_process.map((item, index) => {
                return (
                  <div
                    data-aos="fade-up"
                    className="col-lg-4 s-no-outer"
                    key={index}
                  >
                    <div className="d-flex">
                      <h4 className={`s-no s-no-${index + 1}`}>{index + 1}</h4>
                      <div className="text-outer">
                        <h3 className="main-outer-heading">{item.title}</h3>
                        <div className="d-flex">
                          <RiArrowRightSLine className="right-arrow" />
                          <span className="numbering-text">
                            {item.description1}
                          </span>
                        </div>
                        <div className="d-flex">
                          <RiArrowRightSLine className="right-arrow" />
                          <span className="numbering-text">
                            {item.description_2}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}

              <div
                data-aos="fade-down"
                className="col-lg-6 offset-lg-2 pt-lg-4 numbering-padding-left"
              >
                <div className="at-every-step-line" />
                <p className="numbering-text pl-0 mt-3">
                  At every step of the process, and even before it starts, you
                  can always reach out to your dedicated success manager who
                  will be in close contact with you, answer any questions, and
                  serve as your point of contact.
                </p>
              </div>
            </div>
          </div>
          <img
            data-aos="fade-right"
            src={element2}
            className="img-fluid numbering-section-bottom-img"
            alt="element_2"
          />
        </section>
        <section className="meet-sec">
          <h3 data-aos="fade-left" className="meet-txt">
            Meet Your Dedicated Success Manager
          </h3>
          <button data-aos="fade-left" className="btn meet-btn mt-3">
            Schedule a Meeting Now!
          </button>
        </section>
        <section className="position-relative main-section solutions">
          <img
            data-aos="fade-up"
            src={elementSo2}
            className="img-fluid solutions_left"
            alt="element_solutions_1"
          />
          <div data-aos="fade-left" className="stroke-heading hide-right">
            SOLUTIONS
          </div>
          <div
            data-aos="fade-left"
            className="undrom_img_outer solutions_right"
          >
            <StaticImage
              src="../assets/images/for-student/solutions_image.png"
              placeholder="tracedSVG"
              className="img-fluid undrom_img"
              alt="solutions_image.png"
            />
          </div>
          <div className="time-to-undrom">
            <div className="container">
              <div className="row">
                <div data-aos="fade-down" className="col-lg-6">
                  <h3 className="main-heading solutions_main_heading">
                    Students <br className="d-lg-inline d-none" />
                    First Solutions
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <img
            data-aos="fade-right"
            src={waveSolutions}
            className="img-fluid wave_undrom_right solutions_waves"
            alt="wave_solutions"
          />
        </section>
        <section className="services_details">
          <div className="container">
            <div className="row">
              <div
                data-aos="fade-up"
                className="col-lg-4 offset-lg-1 layer-images safari-margin-top"
              >
                <img src={Layer3} className="img-fluid" alt="Layer_3" />
              </div>
              <div
                data-aos="fade-left"
                className="col-lg-6 offset-lg-1 safari-margin-top services_details_text"
              >
                <h3 className="services_details_heading">
                  Tailored Experience
                </h3>
                <p className="mb-1 font-weight-bold">
                  All the best apartments in one place.
                </p>
                <div className="pl-4">
                  <p className="mb-1">
                    <RiArrowRightSLine className="services_details_arrow" />
                    <span> Filter by walking distance to campus.</span>
                  </p>
                  <p className="mb-1">
                    <RiArrowRightSLine className="services_details_arrow" />
                    <span> Browse student curated listings. </span>
                  </p>
                  <p className="mb-0">
                    <RiArrowRightSLine className="services_details_arrow" />
                    <span> See reviews and ratings from former tenants. </span>
                  </p>
                </div>
              </div>
              <div className="col-12">
                <div className="row space-top reverse-columan">
                  <div
                    data-aos="fade-right"
                    className="col-lg-6 safari-margin-top offset-lg-1 services_details_text"
                  >
                    <h3 className="services_details_heading">Pre-Booking</h3>
                    <p className="mb-1 font-weight-bold">
                      See reviews and ratings from former tenants.
                    </p>
                    <div className="pl-4">
                      <p className="mb-1">
                        <RiArrowRightSLine className="services_details_arrow" />
                        <span> Lease apartments up to 1 year in advance. </span>
                      </p>
                      <p className="mb-1">
                        <RiArrowRightSLine className="services_details_arrow" />
                        <span> Meet the student who lived there before. </span>
                      </p>
                      <p className="mb-0">
                        <RiArrowRightSLine className="services_details_arrow" />
                        <span> Filter by move-in month. </span>
                      </p>
                    </div>
                  </div>
                  <div
                    data-aos="fade-down"
                    className="col-lg-4 safari-margin-top layer-images"
                  >
                    <img src={Layer4} className="img-fluid" alt="Layer_4" />
                  </div>
                </div>
                <div className="row space-top">
                  <div
                    data-aos="fade-left"
                    className="col-lg-4 safari-margin-top offset-lg-1 layer-images"
                  >
                    <img src={Layer5} className="img-fluid" alt="Layer_5" />
                  </div>
                  <div
                    data-aos="fade-down"
                    className="col-lg-6 safari-margin-top offset-lg-1 services_details_text"
                  >
                    <h3 className="services_details_heading">
                      Flexible Leasing
                    </h3>
                    <p className="mb-1 font-weight-bold">
                      Your apartment, your terms. 12 month leases are overrated.
                    </p>
                    <div className="pl-4">
                      <p className="mb-1">
                        <RiArrowRightSLine className="services_details_arrow" />
                        <span> Select spring, fall, and/or summer term. </span>
                      </p>
                      <p className="mb-0">
                        <RiArrowRightSLine className="services_details_arrow" />
                        <span>
                          {" "}
                          Re-list your apt to get connected with potential
                          subletters.{" "}
                        </span>
                      </p>
                    </div>
                    <button className="btn meet-btn btn-find-pad mt-3">
                      Find My Pad
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            data-aos="fade-right"
            src={waveNessageMob}
            className="img-fluid d-lg-none message_wave"
            alt="wave_message"
          />
        </section>
      </>
    </Layout>
  )
}

export const query = graphql`
  {
    strapiFindingAPlace {
      main_heading
      main_para
      main_img {
        localFile {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
      Time_to_undorm_heading
      Time_to_undorm_para
      the_process {
        id
        title
        description1
        description_2
      }
    }
  }
`

export default FindingPlace
